<template>
    <div v-if="isVisible" id="dimmer">
        <img class="spinner" src="/static/loading/spinner1.svg" />
    </div>
</template>

<script>
export default {
    name: 'dimmer',
    props: ['value'],
    data: () => ({ isVisible: false }),
    mounted() {
        this.$emit('update:value', this);
    },
    methods: {
        show() {
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        }
    }
};
</script>

<style>
#dimmer {
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 32px;
    z-index: 5;
}

#dimmer .spinner {
    position: fixed;
    margin: auto;
    width: 20vh;
    text-align: center;
    vertical-align: middle;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/dimmer.vue